import React, { useState, useEffect, useRef } from "react";
import { Container } from "@mui/material";
import ReceiverMessage from "./ReceiverMessage";
import SenderMessages from "./SenderMessages";
import MessageInput from "./MessageInput";
// import DateStatus from "./DateStatus";
import { CustomScrollbarStyle } from "./styles/ScrollbarStyles";
import { ChatMain, MessageContainer } from "./styles/MessageMainStyles";
import { CHATS } from "../../../constants/apiEndPoints";
import httpRequest from "../../../axios/index";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { ReadAllMessages } from "../../../services/messages";
import SmallLoader from "../../shared/loader/SmallLoader";

const MessageMain = () => {
  const { user = {} } = useSelector((state) => state.auth);
  const messageContainerRef = useRef(null);
  const [Loading, setLoading] = useState(false);
  const [AllMessages, SetAllMessages] = useState([]);

  const scrollbarHeight = "75vh";
  const [Page, setPage] = useState(1);
  const [isLastPage, setIsLastPage] = useState(false);
  const prevScrollPositionRef = useRef(0);

  useEffect(() => {
    if (Loading) {
      if (Page === 1) {
        scrollToBottom();
      }
    }
    prevScrollPositionRef.current = messageContainerRef.current.scrollTop;
  }, [AllMessages]);

  useEffect(() => {
    GetAllMessages();
  }, [Page]);

  const scrollToBottom = () => {
    if (messageContainerRef.current) {
      messageContainerRef.current.scrollTop =
        messageContainerRef.current.scrollHeight;
    }
  };

  const GetAllMessages = async () => {
    //&limit=30
    try {
      let param = `?page=${Page}`;
      setLoading(true);
      const resp = await httpRequest.get(`${CHATS}${param}`);
      if (resp?.status === 200 && resp?.data?.message === "Success") {
        if (resp?.data?.data) {
          if (Page === 1) {
            SetAllMessages(resp?.data?.data);
          } else {
            const prevScrollHeight = messageContainerRef.current.scrollHeight;
            SetAllMessages((prevData) => [...prevData, ...resp?.data?.data]);
            // Adjust the scroll position after new data is loaded
            const addedHeight =
              messageContainerRef.current.scrollHeight - prevScrollHeight;

            messageContainerRef.current.scrollTop =
              prevScrollPositionRef.current + addedHeight;
          }
        }

        if (resp?.data?.data && Page === 1) {
          await ReadAllMessages();
        }

        setIsLastPage(resp?.data?.last_page);
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Something went wrong";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  const handleScroll = async (e) => {
    let element = e.target;
    if (element.scrollTop === 0 && !Loading && !isLastPage) {
      await loadMoreMessages();
    }
  };
  const loadMoreMessages = async () => {
    if (!Loading && !isLastPage) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  return (
    <Container maxWidth="lg">
      <ChatMain className="ChatMain">
        <MessageContainer>
          <CustomScrollbarStyle
            scrollbarHeight={scrollbarHeight}
            ref={messageContainerRef}
            onScroll={handleScroll}
          >
            {Loading && <SmallLoader center={true} />}
            {!Loading && (
              <>
                {AllMessages && AllMessages.length < 0 && (
                  <span className="no_message_text">No Message.</span>
                )}
              </>
            )}
            {AllMessages &&
              AllMessages?.slice()
                ?.reverse()
                ?.map((message, index) => {
                  if (user?.id === message?.sender_id) {
                    return (
                      <SenderMessages
                        key={index}
                        message={message?.message}
                        date={message?.created_at}
                        attachments={message?.attachments_urls}
                      />
                    );
                  } else {
                    return (
                      <ReceiverMessage
                        key={index}
                        message={message?.message}
                        date={message?.created_at}
                        attachments={message?.attachments_urls}
                      />
                    );
                  }
                })}
          </CustomScrollbarStyle>
          <MessageInput
            SetAllMessages={SetAllMessages}
            AllMessages={AllMessages}
            scrollToBottom={scrollToBottom}
          />
        </MessageContainer>
      </ChatMain>
    </Container>
  );
};

export default MessageMain;
